/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';

import { State } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { filter$, map$ } from '@gh/rx/operators';

import { negate } from 'lodash';
import { Observable, Subscription } from 'rxjs';

import { JeColorSelection } from '../../../resources/job-estimate-details.model';
import { JeCommandService } from '../je-command.service';
import {
  JeDetailsState,
  queryJeEditable,
  queryJeSelectedCostCenter,
  queryJeSelectedCostCenterId,
  queryJeSelectedItemId,
} from '../je-details.state';

@Component({
  standalone: false,
  selector: 'gh-je-details-cc-parent',
  templateUrl: 'je-details-cc-parent.component.html',
  styleUrls: ['je-details-cc-parent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JeDetailsCcParentComponent implements OnInit, OnDestroy {
  memo$: Observable<string>;
  hasSelectedItem$: Observable<boolean>;
  colorSelections$: Observable<JeColorSelection[]>;

  editable$: Observable<boolean>;
  costCenterId: ID;

  selectedTab: string;

  private costCenterIdSubscription: Subscription;

  constructor(private state: State<JeDetailsState>,
              private commands: JeCommandService) {
  }

  ngOnInit(): void {
    const costCenterId$ = this.state.select(queryJeSelectedCostCenterId).pipe(filter$(Boolean));
    this.memo$ = this.state.select(queryJeSelectedCostCenter).pipe(map$((cc) => cc && cc.memo || ''));
    this.hasSelectedItem$ = this.state.select(queryJeSelectedItemId).pipe(map$(negate(Boolean)));
    this.colorSelections$ = this.state.select(queryJeSelectedCostCenter).pipe(
      filter$(Boolean),
      map$((cc: any) => cc.jobColorSelection));

    this.editable$ = this.state.select(queryJeEditable);

    this.costCenterIdSubscription = costCenterId$.subscribe((id: any) => this.costCenterId = id);
  }

  ngOnDestroy(): void {
    this.costCenterIdSubscription.unsubscribe();
  }

  onMemoChange(memo: string): void {
    const { costCenterId } = this;

    if (costCenterId) {
      this.commands.costCenterSetField(costCenterId, 'memo', memo);
    }
  }
}
